// extracted by mini-css-extract-plugin
export var avatarContainer = "_g9-0";
export var avatarTypingWave = "_g9-i";
export var gray = "_g9-f";
export var green = "_g9-c";
export var icon = "_g9-9";
export var image = "_g9-1";
export var lg = "_g9-6";
export var md = "_g9-5";
export var presenceDot = "_g9-b";
export var red = "_g9-d";
export var sm = "_g9-4";
export var status = "_g9-a";
export var typingDot = "_g9-h";
export var typingPill = "_g9-g";
export var xl = "_g9-7";
export var xs = "_g9-3";
export var xxl = "_g9-8";
export var xxs = "_g9-2";
export var yellow = "_g9-e";